var _style, _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomBtnarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#EBEBEB;stroke-width:2;}\n\t.st2{fill:#FCFCFC;fill-opacity:0;}\n\t.st3{fill:none;stroke:#FCFCFC;stroke-width:1.333;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#FCFCFC;stroke-miterlimit:10;}\n\t.st5{fill:#FCFCFC;}\n\t.st6{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4655.397 4767.319) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4695.397 4727.319)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 20,
    r: 19
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4683.421 4739.579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.3,
    className: "st2",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.686 5.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.3,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.3-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.3,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.3-1.7"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,19.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 20,
    y1: 23.7,
    x2: 20,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "24.1,19.1 23.3,19.7 20,16.1 16.6,19.7 15.9,19 20,14.7  "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.7,19.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBtnarrow);
export default __webpack_public_path__ + "static/media/customBtnarrow.c12ab4e7.svg";
export { ForwardRef as ReactComponent };